/* eslint-disable guard-for-in */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueI18n from 'vue-i18n';
import 'simple-line-icons/css/simple-line-icons.css';
import '@mdi/font/css/materialdesignicons.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon.vue';
import '../assets/scss/style.scss';
import Notify from 'vue2-notify';
import vSelect from 'vue-select';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import RoundSlider from 'vue-round-slider';
import InputValidation from './components/lib/InputValidation.vue';
import Autocomplete from './components/lib/Autocomplete.vue';
import store from './store/index';
import router from './router';
import App from './App.vue';

// TODO remove this and use lower one
Vue.component('v-select', vSelect);
Vue.component('multiselect', Multiselect);
Vue.component('round-slider', RoundSlider);

Vue.use(Notify, { position: 'top-right' });
Vue.$notify.notice = (data) =>
{
    if (typeof data === 'object' && typeof data.error !== 'undefined')
    {
        let notice = '';
        if (typeof data.fieldErrors !== 'undefined')
        {
            for (const key in data.fieldErrors)
            {
                notice += `${data.fieldErrors[key]}<br>`;
            }
        }
        else
        {
            notice = data.notice;
        }

        if (data.error)
        {
            Vue.$notify.error(notice, { mode: 'html' });
        }
        else
        {
            Vue.$notify.info(notice, { mode: 'html' });
        }
    }
    else
    {
        Vue.$notify.info(data, { mode: 'html' });
    }
};

Vue.use(BootstrapVue);
Vue.use(VueI18n);

Vue.component('icon', Icon);
Vue.component('autocomplete', Autocomplete);
Vue.component('inputvalidation', InputValidation);

Vue.config.productionTip = false;
const i18n = new VueI18n({});

new Vue({
    router,
    store,
    i18n,
    template: '<App/>',
    components:
    {
        App,
    },
}).$mount('#app');
